export default __webpack_public_path__ + "static/cmc-w-logo-1dff9cbb1cc1011cf40e40f493e2ce37.png";